import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Generic kanban card for `pp-kboard` columns (leads, quotations, …).
 * Same layout as the jobs board card: ref + priority, title, client/subtitle, date footer.
 */
@Component({
  selector: 'app-record-board-card',
  templateUrl: './record-board-card.component.html',
  styleUrls: ['./record-board-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecordBoardCardComponent {
  @Input() ref = '';
  @Input() heading = '';
  @Input() client = '';
  @Input() subtitle = '';
  @Input() date: string | Date | null | undefined = null;
  @Input() dateLabel = '';
  @Input() emptyDateText = 'No date';
  @Input() dateTone: 'overdue' | 'today' | '' = '';
  @Input() priorityLabel = '';
  @Input() priorityColor = '';
  @Input() stripeColor = '';
  @Input() phone = '';
  @Input() tag = '';
  @Input() dragging = false;
  /** Shows the ⋮ button; the page opens its own menu from `menuClick`. */
  @Input() menu = false;

  @Output() open = new EventEmitter<void>();
  @Output() menuDown = new EventEmitter<MouseEvent>();
  @Output() menuClick = new EventEmitter<MouseEvent>();

  onOpen(event: Event): void {
    if ((event.target as HTMLElement).closest('a, button')) return;
    this.open.emit();
  }
}
